// AUTO-GENERATED GraphQL Builder for PackageItem
import * as Builders from '../';
export class PackageItemBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  offeringPackageId(){ return this.add('offeringPackageId'); }
  offeringId(){ return this.add('offeringId'); }
  srcMode(){ return this.add('srcMode'); }
  srcOfferingPackageId(){ return this.add('srcOfferingPackageId'); }
  srcEventSessionId(){ return this.add('srcEventSessionId'); }
  heads(){ return this.add('heads'); }
  extraPrice(){ return this.add('extraPrice'); }
  sortOrder(){ return this.add('sortOrder'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  offering(b?:(q:Builders.OfferingBuilder)=>void){
    if(this.depth>=5||this.v.has('offering'))return this;
    this.v.add('offering');
    const n=new Builders.OfferingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offering { ${inner} }`);
    return this;
  }

  offeringPackage(b?:(q:Builders.OfferingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringPackage'))return this;
    this.v.add('offeringPackage');
    const n=new Builders.OfferingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringPackage { ${inner} }`);
    return this;
  }

  srcEventSession(b?:(q:Builders.EventSessionBuilder)=>void){
    if(this.depth>=5||this.v.has('srcEventSession'))return this;
    this.v.add('srcEventSession');
    const n=new Builders.EventSessionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`srcEventSession { ${inner} }`);
    return this;
  }

  srcOfferingPackage(b?:(q:Builders.OfferingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('srcOfferingPackage'))return this;
    this.v.add('srcOfferingPackage');
    const n=new Builders.OfferingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`srcOfferingPackage { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  bookingPackageItemQtyList(b?:(q:Builders.BookingPackageItemQtyBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackageItemQtyList'))return this;
    this.v.add('bookingPackageItemQtyList');
    const n=new Builders.BookingPackageItemQtyBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageItemQtyList { ${inner} }`);
    return this;
  }

  offeringMilestoneShareList(b?:(q:Builders.OfferingMilestoneShareBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringMilestoneShareList'))return this;
    this.v.add('offeringMilestoneShareList');
    const n=new Builders.OfferingMilestoneShareBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringMilestoneShareList { ${inner} }`);
    return this;
  }

  reverseBookingPackageItemQty(b?:(q:Builders.BookingPackageItemQtyBuilder)=>void){
    const n=new Builders.BookingPackageItemQtyBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageItemQtyList { ${inner} }`);
    return this;
  }

  reverseOfferingMilestoneShare(b?:(q:Builders.OfferingMilestoneShareBuilder)=>void){
    const n=new Builders.OfferingMilestoneShareBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringMilestoneShareList { ${inner} }`);
    return this;
  }
}
